module.exports = __webpack_public_path__ + "media/payment/mastercard-icon-f23ccf66.svg";